import React from "react";
import { Route } from "react-router-dom";
import Alumni from "../pages/Alumni";
import ProudAlumni from "../page_content/Alumni/ProudAlumni";
// import AlumniRegistration from "../page_content/Alumni/AlumniRegistration";


export const AlumniRoutes = (
  <Route path="alumni" element={<Alumni />}>
    <Route path="proud-alumni" element={<ProudAlumni />} />
    {/* <Route path="alumni-registration" element={<AlumniRegistration />} /> */}
  </Route>
);




